document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('locations-califonia');

  if (!section) return;

  const searchInput = document.getElementById('location-search-califonia');
  const searchButton = document.getElementById('location-search-button-califonia');
  const noResults = document.getElementById('locations-no-results-califonia');
  const nearbyMessage = document.getElementById('locations-nearby-message-califonia');

  if (!searchInput) return;

  /*
   * Prepare location data only once.
   */
  const locations = Array.from(
    section.querySelectorAll('[data-location]')
  ).map(function (location) {
    return {
      element: location,
      search: (location.getAttribute('data-search') || '').toLowerCase(),
      zip: (location.getAttribute('data-zip') || '').trim(),
      nearbyZips: (location.getAttribute('data-nearby-zips') || '')
        .split(',')
        .map(function (zip) {
          return zip.trim();
        })
        .filter(Boolean)
    };
  });

  function filterLocations() {
    const searchValue = searchInput.value.trim().toLowerCase();
    const isZipSearch = /^\d{5}$/.test(searchValue);

    let visibleCount = 0;
    let nearbyMatch = false;

    locations.forEach(function (location) {
      let isMatch = false;

      if (isZipSearch) {
        /*
         * Exact ZIP match.
         */
        if (location.zip === searchValue) {
          isMatch = true;
        }

        /*
         * Nearby ZIP match.
         */
        else if (location.nearbyZips.includes(searchValue)) {
          isMatch = true;
          nearbyMatch = true;
        }
      } else {
        /*
         * Location name, city, address, etc.
         */
        isMatch =
          searchValue === '' ||
          location.search.includes(searchValue);
      }

      location.element.style.display = isMatch ? '' : 'none';

      if (isMatch) {
        visibleCount++;
      }
    });

    /*
     * Nearby message.
     */
    if (nearbyMessage) {
      nearbyMessage.hidden = !nearbyMatch;
    }

    /*
     * No results message.
     */
    if (noResults) {
      noResults.hidden = visibleCount > 0;
    }
  }

  /*
   * Search while typing.
   */
  searchInput.addEventListener('input', filterLocations);

  /*
   * Search button.
   */
  if (searchButton) {
    searchButton.addEventListener('click', filterLocations);
  }

  /*
   * Enter key.
   */
  searchInput.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      filterLocations();
    }
  });
});